import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/import';

// Thunks

export const createVerificationSessionsFromList = createAsyncThunk(
  'import/createVerificationSessionsFromList',
  async ({ clientId, reservations }, { rejectWithValue }) => {
    try {
      const data = await api.createVerificationSessionsFromList(clientId, reservations);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Slice

export const importSlice = createSlice({
  name: 'import',
  initialState: {
    reservations: [],
    reservationsResults: [],
    isPending: false,
  },
  reducers: {
    setReservations(state, action) {
      state.reservations = action.payload;
    },
    setReservationsResults(state, action) {
      state.reservationsResults = action.payload;
    },
  },
  extraReducers: {
    [createVerificationSessionsFromList.rejected]: (state) => {
      state.isPending = false;
    },
    [createVerificationSessionsFromList.pending]: (state) => {
      state.isPending = true;
    },
    [createVerificationSessionsFromList.fulfilled]: (state, action) => {
      state.reservationsResults = action.payload;
      state.isPending = false;
    },
  },
});

// Actions

export const {
  setReservations,
  setReservationsResults,
} = importSlice.actions;

// Selectors

export const selectReservations = (state) => state.import.reservations;
export const selectReservationsResults = (state) => state.import.reservationsResults.map((r, index) => ({
  result: r.result,
  message: r.message,
  ...state.import.reservations[index],
}));
export const selectIsPending = (state) => state.import.isPending;

// Reducer

export default importSlice.reducer;
